/**
 * Permisos del backoffice por rol (admin, gestor legacy, operario, consultor).
 * Las comprobaciones de seguridad definitivas están en el API (user.utils).
 */

export const BACKOFFICE_STAFF_ROLES = [
  "admin",
  "operario",
  "consultor",
  "congreso_delegado",
];

export function isAdminRole(role) {
  return role === "admin" || role === "gestor";
}

export function isConsultor(role) {
  return role === "consultor";
}

export function isOperario(role) {
  return role === "operario";
}

export function isCongresoDelegado(role) {
  return role === "congreso_delegado";
}

/** Alta de ediciones nuevas: no aplica al delegado de congreso */
export function canCreateCongresoEdicion(role) {
  return (
    canEditGestionModule(role) &&
    !isReadOnlyConsultor(role) &&
    !isCongresoDelegado(role)
  );
}

/** Panel delegados en edición (admin u operario) */
export function canManageCongresoDelegadosUi(role) {
  return isAdminRole(role) || isOperario(role);
}

/** Solo lectura (consultor en todo el backoffice a nivel de mutaciones) */
export function isReadOnlyConsultor(role) {
  return role === "consultor";
}

/** Contenido / config solo admin+gestor (banners, textos, categorías, noticias…) */
export function canEditAdminContent(role) {
  return isAdminRole(role);
}

/** Usuarios (listas, socios, docentes, altas…) */
export function canEditUsersModule(role) {
  return isAdminRole(role) || isOperario(role);
}

/** Gestión operativa: contactos, eventos, empleos, mailings/newsletters, pagos operativos */
export function canEditGestionModule(role) {
  return isAdminRole(role) || isOperario(role);
}

/** Migraciones de pago / acciones masivas sensibles */
export function canEditPaymentMigration(role) {
  return isAdminRole(role);
}

/** Cobros operativos, recordatorios, validación estudiantes */
export function canEditPaymentOperations(role) {
  return canEditGestionModule(role);
}

/** Administradores del sistema */
export function canEditAdminsModule(role) {
  return isAdminRole(role);
}

/** Cursos: operario y consultor no editan estructura de curso */
export function isCursoReadOnly(role) {
  return isConsultor(role) || isOperario(role);
}

export function showPaymentMenu(role) {
  return isAdminRole(role) || isOperario(role) || isConsultor(role);
}

/** Menú misc (idiomas, textos, tipos usuario, geo…) */
export function showMiscConfigMenu(role) {
  return isAdminRole(role) || isConsultor(role);
}

/** Banners / imágenes */
export function showBannersImagenesMenu(role) {
  return isAdminRole(role) || isConsultor(role);
}
